import {
  HomeIcon, TasksIcon, MoreIcon, TransactionsIcon,
} from 'public/icons';

import { configurations, tabs, path } from 'pages/routes';

import { USER_TYPES } from 'resources/user/user.constants';

const { bottomTabs } = tabs;

const bottomTab = {
  [bottomTabs.HOME]: {
    name: bottomTabs.HOME,
    icon: HomeIcon,
    defaultPath: path.home,
  },
  [bottomTabs.TASKS]: {
    name: bottomTabs.TASKS,
    icon: TasksIcon,
    defaultPath: path.tasks,
  },
  [bottomTabs.TRANSACTIONS]: {
    name: bottomTabs.TRANSACTIONS,
    icon: TransactionsIcon,
    defaultPath: path.transactions,
  },
  [bottomTabs.MORE]: {
    name: bottomTabs.MORE,
    icon: MoreIcon,
  },
};

const realtorMenuTabs = [
  bottomTabs.HOME,
  bottomTabs.TASKS,
  bottomTabs.TRANSACTIONS,
  bottomTabs.MORE,
];

const clientMenuTabs = [
  bottomTabs.HOME,
  bottomTabs.TASKS,
  bottomTabs.MORE,
];

const marketingMenuTabs = [
  bottomTabs.HOME,
  bottomTabs.TASKS,
  bottomTabs.TRANSACTIONS,
  bottomTabs.MORE,
];

const userTypeToMenuTabs = {
  [USER_TYPES.REALTOR]: realtorMenuTabs,
  [USER_TYPES.COORDINATOR]: realtorMenuTabs,
  [USER_TYPES.ADMIN]: realtorMenuTabs,
  [USER_TYPES.CLIENT]: clientMenuTabs,
};

const getMenuTabs = (user, company) => {
  const menuTabs = (!user?.type
    ? marketingMenuTabs
    : userTypeToMenuTabs[user.type]
  ).map((tabName) => bottomTab[tabName]);

  return menuTabs.map((tab) => {
    const tabPaths = configurations(user, company).reduce((acc, pageData) => {
      if (pageData.tab === tab.name) {
        acc.push(pageData.path);
      }

      return acc;
    }, []);

    return {
      ...tab,
      paths: tabPaths,
    };
  });
};

export default getMenuTabs;
